var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-container" }, [
    _c("canvas", { attrs: { id: "canvas" } }),
    _vm._m(0),
    _c(
      "div",
      { staticClass: "content-box" },
      [
        _c("img", {
          attrs: { src: require("../../assets/loginLeft.png"), alt: "" }
        }),
        _c(
          "el-form",
          {
            ref: "loginForm",
            staticClass: "login-form",
            staticStyle: { "margin-top": "0" },
            attrs: {
              model: _vm.loginForm,
              rules: _vm.loginRules,
              "auto-complete": "on",
              "label-position": "left"
            }
          },
          [
            _c("div", { staticClass: "fromTitle" }, [
              _c("p", [_vm._v("iMango4.0新闻采集")]),
              _vm._v(" 管理系统平台 ")
            ]),
            _c(
              "el-form-item",
              {
                staticClass: "loginName",
                staticStyle: { "margin-bottom": "28px" },
                attrs: { prop: "username" }
              },
              [
                _c("el-input", {
                  attrs: {
                    name: "username",
                    type: "text",
                    "auto-complete": "on",
                    placeholder: _vm.$t("Username")
                  },
                  model: {
                    value: _vm.loginForm.username,
                    callback: function($$v) {
                      _vm.$set(_vm.loginForm, "username", $$v)
                    },
                    expression: "loginForm.username"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                staticClass: "loginName",
                staticStyle: { "margin-bottom": "28px" },
                attrs: { prop: "password" }
              },
              [
                _c("el-input", {
                  attrs: {
                    type: _vm.pwdType,
                    name: "password",
                    "auto-complete": "on",
                    placeholder: _vm.$t("Password")
                  },
                  nativeOn: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.onKeyEnter($event)
                    }
                  },
                  model: {
                    value: _vm.loginForm.password,
                    callback: function($$v) {
                      _vm.$set(_vm.loginForm, "password", $$v)
                    },
                    expression: "loginForm.password"
                  }
                })
              ],
              1
            ),
            _vm.isSignUp
              ? _c(
                  "el-form-item",
                  {
                    staticStyle: { "margin-bottom": "28px" },
                    attrs: { prop: "confirmPassword" }
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        type: _vm.pwdType,
                        name: "password",
                        "auto-complete": "on",
                        placeholder: _vm.$t("Confirm Password")
                      },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.onKeyEnter($event)
                        }
                      },
                      model: {
                        value: _vm.loginForm.confirmPassword,
                        callback: function($$v) {
                          _vm.$set(_vm.loginForm, "confirmPassword", $$v)
                        },
                        expression: "loginForm.confirmPassword"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.isSignUp
              ? _c(
                  "el-form-item",
                  {
                    staticStyle: { "margin-bottom": "28px" },
                    attrs: { prop: "email" }
                  },
                  [
                    _c("el-input", {
                      attrs: { name: "email", placeholder: _vm.$t("Email") },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.onKeyEnter($event)
                        }
                      },
                      model: {
                        value: _vm.loginForm.email,
                        callback: function($$v) {
                          _vm.$set(_vm.loginForm, "email", $$v)
                        },
                        expression: "loginForm.email"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-form-item",
              { staticClass: "loginButton", staticStyle: { border: "none" } },
              [
                _vm.isSignUp
                  ? _c(
                      "el-button",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { loading: _vm.loading, type: "primary" },
                        nativeOn: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.handleSignup($event)
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("Sign up")) + " ")]
                    )
                  : _vm._e(),
                !_vm.isSignUp
                  ? _c(
                      "el-button",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { loading: _vm.loading, type: "primary" },
                        nativeOn: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.handleLogin($event)
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("Sign in")) + " ")]
                    )
                  : _vm._e()
              ],
              1
            ),
            _c("div", { staticClass: "alternatives" }, [
              _vm.setting.allow_register === "Y"
                ? _c("div", { staticClass: "right" }, [
                    _vm.isSignUp
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.$t("Has Account")) + ", ")
                        ])
                      : _vm._e(),
                    _vm.isSignUp
                      ? _c(
                          "span",
                          {
                            staticClass: "sign-in",
                            on: {
                              click: function($event) {
                                return _vm.$router.push("/login")
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("Sign-in")) + " >")]
                        )
                      : _vm._e(),
                    !_vm.isSignUp
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.$t("New to iMango")) + ", ")
                        ])
                      : _vm._e(),
                    !_vm.isSignUp
                      ? _c(
                          "span",
                          {
                            staticClass: "sign-up",
                            on: {
                              click: function($event) {
                                return _vm.$router.push("/signup")
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("Sign-up")) + " >")]
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ]),
            _vm.isShowMobileWarning
              ? _c("div", { staticClass: "mobile-warning" })
              : _vm._e()
          ],
          1
        )
      ],
      1
    ),
    _vm._m(1)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "h3",
      {
        staticClass: "title",
        staticStyle: { "padding-top": "155px", "font-size": "38px" }
      },
      [
        _c("img", {
          attrs: { src: require("../../assets/hnBf.png"), alt: "" }
        }),
        _vm._v("5G智慧电台")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "login-bottom" }, [
      _c("p", [_vm._v("5G智慧电台 把党的声音送到田间地头")]),
      _c("p", [_vm._v("5G Smart Radio Send the Party's voice to the fields")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }